import { getDefaultAddressSchemeTypeByCountry } from '@components'

import { InvoiceFormReceiver } from '../../../../invoices/types/invoiceForm/invoiceFormReceiver'
import { XRechnungEInvoicingAddressForm } from '../../../types/xRechnungEInvoicingAddressForm'

export const getCustomerEInvoicingAddressValues = (
  customer?: InvoiceFormReceiver | null,
): XRechnungEInvoicingAddressForm => {
  const { ean, countryId, publicEntityRoutingEnabled, eInvoiceScheme } = customer || {}
  const defaultEInvoiceScheme = getDefaultAddressSchemeTypeByCountry(!!publicEntityRoutingEnabled, countryId)
  const selectedEInvoiceScheme = eInvoiceScheme || defaultEInvoiceScheme

  return {
    ean: ean || '',
    eInvoiceScheme: selectedEInvoiceScheme || '',
    publicEntityRoutingEnabled,
  }
}
